import { render, staticRenderFns } from "./TestSessionCard.vue?vue&type=template&id=45495c3f&scoped=true&"
import script from "./TestSessionCard.vue?vue&type=script&lang=js&"
export * from "./TestSessionCard.vue?vue&type=script&lang=js&"
import style0 from "./TestSessionCard.vue?vue&type=style&index=0&id=45495c3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45495c3f",
  null
  
)

export default component.exports